import { Component, OnInit } from '@angular/core';
import {Usuario} from '../../../../../models/usuario.interface';
import {UsuarioService} from '../../../../services/usuario/usuario.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {

  usuarioB: Usuario;

  showModal = false;
  mensagens = [];

  constructor(
    private readonly usuarioService: UsuarioService,
    private readonly router: Router
  ) {
    this.usuarioB = JSON.parse(window.localStorage.getItem('usuario'));
  }

  ngOnInit(): void {
  }

  handleOpenModal() {
    this.showModal = !this.showModal;
  }

  logout() {
    window.localStorage.removeItem('usuario');
    this.usuarioService.removeTk();
    this.router.navigate(['/login']);
  }

}
